// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"home_wrapper__1UeR8","footer":"home_footer__rm51Y"};